<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-11.5 780.5 24 24">
    <path
      d="M0.5,799.07c1.37,0,2.5-1.09,2.54-2.46l0,0v-4.24l-2.54,2.55l-2.55-2.55v4.24l0,0C-2,797.99-0.87,799.18,0.5,799.07z" />
    <polygon points="3.05,790.95 3.05,789.62 0.5,782.5 -2.05,789.62 -2.05,790.95 0.5,793.49 " />
    <path
      d="M-5.41,795.54c0,3.27,2.65,5.92,5.91,5.92s5.92-2.65,5.92-5.92v-5.19l0.72-0.5l-0.97-3.72l-0.97,3.72l0.72,0.5v5.19
	c0,2.99-2.42,5.41-5.41,5.41c-2.99,0-5.41-2.42-5.41-5.41v-5.19l0.72-0.5l-0.97-3.73l-0.97,3.72l0.72,0.5V795.54z" />
    <path
      d="M8.05,788.93l-0.97,3.73l0.72,0.5v1.42c0.06,4.03-3.16,7.35-7.19,7.41c-4.03,0.06-7.35-3.16-7.41-7.19c0-0.07,0-0.15,0-0.22
	v-1.42l0.72-0.5l-0.97-3.73l-0.97,3.73l0.72,0.5v1.42c-0.06,4.31,3.38,7.85,7.69,7.92c4.31,0.06,7.85-3.38,7.92-7.69
	c0-0.08,0-0.15,0-0.23v-1.42l0.72-0.5L8.05,788.93z" />
    <path
      d="M-3.53,796.37c0,2.22,1.8,4.03,4.03,4.03s4.03-1.8,4.03-4.03v-8.83l0.72-0.51l-0.97-3.73l-0.97,3.72l0.72,0.5v8.83
	c0,1.95-1.58,3.52-3.52,3.52s-3.52-1.58-3.52-3.52l0,0v-8.83l0.72-0.51l-0.97-3.73l-0.97,3.72l0.72,0.5V796.37z" />
  </svg>
</template>
